// extracted by mini-css-extract-plugin
export var jumbotron = "index-module--jumbotron--1EOLL";
export var background = "index-module--background--2U9gK";
export var image = "index-module--image--20Bd7";